import { Helmet } from 'react-helmet-async';
import { resolveApiAsset } from '../../utils/image';

const SEO = ({
  title,
  description,
  keywords,
  url,
  image,
  type = 'website',
}) => {
  const siteName = 'Ekamithila';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const defaultDescription = 'Discover and shop the best products online at Ekamithila. Books, dry fruits, automobiles and more.';
  const desc = description || defaultDescription;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={resolveApiAsset(image)} />}
      <meta property="og:site_name" content={siteName} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {image && <meta name="twitter:image" content={resolveApiAsset(image)} />}
    </Helmet>
  );
};

export default SEO;
